import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { addSkillMedia } from "../../Services/SkillService";

const AddSkillMedia = ({ data, onClose, onCloseWithApi }) => {
    const [reqData, setReqData] = useState({
        id: "",
        skill_id: "",
        media_type: "",
        platform: "",
        url: "",
        type: ""
    });
    const [loader, setLoader] = useState(false);

    const handleChange = (field, value) => {
        setReqData({ ...reqData, [field]: value })
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);
        let { ok } = await addSkillMedia(reqData);
        if (ok) {
            toast.success("Success");
            onCloseWithApi();
        }
        setLoader(false);
    };

    useEffect(() => {
        if (data?.data) {
            const { id, skill_id, media_type, type, url, platform } = data?.data;
            setReqData({ id, skill_id, media_type, type, url, platform });
        }
    }, []);

    return (
        <div
            className="modal modal-fullscreen custom-modal fade bank-details show"
            id="add_items"
            role="dialog"
            aria-modal="true"
            style={{
                display: "block",
                background: "rgb(0 0 0 / 50%)",
            }}
        >
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header text-start mb-0">
                                <h4 className="mb-0">{!reqData?.id ? "Add Media" : "Edit Media"}</h4>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onClose()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="bank-inner-details">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label>Type</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Type"
                                                required
                                                value={reqData?.type}
                                                onChange={(e) => handleChange("type", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Media Type</label>
                                            <select required value={reqData?.media_type} onChange={(e) => handleChange("media_type", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option value="">Select Media</option>
                                                <option value="video">Video</option>
                                                <option value="iamge">Image</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Platform</label>
                                            <select required value={reqData?.platform} onChange={(e) => handleChange("platform", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option value="">Select Platform</option>
                                                <option value="youtube">YouTube</option>
                                                <option value="s3">S3</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Link</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Link"
                                                required
                                                value={reqData?.url}
                                                onChange={(e) => handleChange("url", e?.target?.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <div className="bank-details-btn">
                                    <button
                                        data-bs-dismiss="modal"
                                        className="btn bank-cancel-btn me-2"
                                        onClick={() => onClose()}
                                        disabled={loader}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn bank-save-btn me-2"
                                        disabled={loader}
                                    >
                                        {loader ? "Loading..." : "Save"}
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default AddSkillMedia;